import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { brand } from "../content/siteContent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("otp_admin_token")) navigate("/admin");
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("otp_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy flex items-center justify-center relative overflow-hidden px-6">
      <div className="absolute inset-0 blueprint opacity-50" />
      <div className="relative w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <Lock className="h-4 w-4 text-teal" />
          <span className="eyebrow text-teal">Admin access</span>
        </div>
        <h1 className="font-display font-extrabold text-white text-2xl tracking-tight">{brand.shortName} Leads Dashboard</h1>
        <p className="mt-2 text-white/60 text-sm">Sign in to review and export prospectus enquiries.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label htmlFor="email" className="block text-xs font-display font-semibold text-white/80 mb-1.5">Email</label>
            <input id="email" type="email" data-testid="admin-email" required value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-navy-2 border border-hair-dark rounded-sm px-4 py-3 text-sm text-white focus:outline-none focus:border-teal transition-colors" />
          </div>
          <div>
            <label htmlFor="password" className="block text-xs font-display font-semibold text-white/80 mb-1.5">Password</label>
            <input id="password" type="password" data-testid="admin-password" required value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-navy-2 border border-hair-dark rounded-sm px-4 py-3 text-sm text-white focus:outline-none focus:border-teal transition-colors" />
          </div>
          {error && <p className="text-sm text-[#f87171]" role="alert" data-testid="admin-error">{error}</p>}
          <button type="submit" data-testid="admin-login-submit" disabled={loading}
            className="w-full bg-teal text-white font-display font-semibold text-sm rounded-sm py-3.5 hover:bg-[#08929f] transition-colors flex items-center justify-center disabled:opacity-60">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
